var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/welcomemsg/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"welcomemsg-body\">   \n    <div class=\"welcomemsg-avatar\">\n        <img src=\"//gw.alicdn.com/tfs/TB1UziCSVXXXXbNXpXXXXXXXXXX-480-480.png\" alt=\"avatar\">\n    </div>\n    <div class=\"welcomemsg-text\">\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"welcomemsg-actions\">\n        ";
output += "\n    </div>\n    ";
output += "\n</div>\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"showLiveAgent")) {
output += "\n";
output += "\n";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/welcomemsg/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/welcomemsg/tpl.html
// module id = 257
// module chunks = 0 1